import React from "react";
import { Youtube, Facebook, Twitter, Mail } from "lucide-react";

const CHANNEL_URL = "https://www.youtube.com/channel/UCLpwX8aPs_ha-BC4bgQwVwg";
const LOGO = "https://customer-assets.emergentagent.com/job_creator-website-1/artifacts/44xcjtke_A%20logo%202.png";

export default function Footer({ stats }) {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/5 pt-20 pb-8 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img src={LOGO} alt="ARSOV" className="h-12 w-12 object-contain" />
              <span className="font-display text-3xl tracking-wider">ARSOV</span>
            </div>
            <p className="text-white/60 text-base max-w-md leading-relaxed">
              Gaming, POV, Music and MTB. Subscribe to catch
              every drop in 4K.
            </p>
            {stats?.subscriber_count != null && !stats.hidden_subscriber_count && (
              <p
                data-testid="footer-sub-count"
                className="mt-5 font-mono-tech text-[10px] uppercase tracking-[0.3em] text-white/40"
              >
                Joined by {Number(stats.subscriber_count).toLocaleString()} subscribers
              </p>
            )}
            <a
              href={CHANNEL_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-subscribe-btn"
              className="mt-8 inline-flex items-center gap-2 bg-[#C41E3A] hover:bg-white text-white hover:text-[#C41E3A] px-6 py-3 text-xs uppercase tracking-[0.3em] font-semibold transition-colors duration-300"
            >
              <Youtube className="w-4 h-4" /> Subscribe on YouTube
            </a>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <p className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-white/40 mb-5">
              Navigate
            </p>
            <ul className="space-y-3 text-white/80">
              <li><a href="#videos" className="nav-link inline-block text-sm uppercase tracking-[0.2em]">Videos</a></li>
              <li><a href="#brand" className="nav-link inline-block text-sm uppercase tracking-[0.2em]">Brand</a></li>
              <li><a href="#about" className="nav-link inline-block text-sm uppercase tracking-[0.2em]">About</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-white/40 mb-5">
              Connect
            </p>
            <ul className="space-y-3">
              <li>
                <a href={CHANNEL_URL} target="_blank" rel="noreferrer" className="nav-link inline-flex items-center gap-2 text-sm uppercase tracking-[0.2em] text-white/80" data-testid="footer-yt">
                  <Youtube className="w-4 h-4" /> YouTube
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/arsov.official" target="_blank" rel="noreferrer" className="nav-link inline-flex items-center gap-2 text-sm uppercase tracking-[0.2em] text-white/80">
                  <Facebook className="w-4 h-4" /> Facebook
                </a>
              </li>
              <li>
                <a href="https://x.com/ARSOV_a" target="_blank" rel="noreferrer" className="nav-link inline-flex items-center gap-2 text-sm uppercase tracking-[0.2em] text-white/80">
                  <Twitter className="w-4 h-4" /> X / Twitter
                </a>
              </li>
              <li>
                <a
  href="mailto:arsen.arsov@yahoo.com"
  target="_blank"
  rel="noreferrer"
  style={{ position: "relative", zIndex: 9999 }}
  className="select-text nav-link inline-flex items-center gap-2 text-sm uppercase tracking-[0.2em] text-white/80"
  data-testid="footer-email"
>
  <Mail className="w-4 h-4" /> arsen.arsov@yahoo.com
</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Massive ARSOV wordmark */}
        <div className="relative leading-none select-none">
          <h3 className="font-display uppercase text-white/[0.07] tracking-tighter text-[24vw] md:text-[19vw] leading-[0.8]">
            ARSOV
          </h3>
          <div className="absolute inset-x-0 bottom-3 h-px bg-white/10 -z-10" />
        </div>

        <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 font-mono-tech text-[10px] uppercase tracking-[0.3em] text-white/40">
          <span>© {year} ARSOV. Shot in 4K. Edited with feeling.</span>
          <span>Made by ARSOV </span>
        </div>
      </div>
    </footer>
  );
}
